export const STATIC_LINK_DRAWER = {
    dashboards: 'https://doc.scananalytics.ru/dashbordy/',
    svodka: 'https://doc.scananalytics.ru/svodka/',
    reports: 'https://doc.scananalytics.ru/otchety/tipy-otchetov-i-chem-oni-otlichayutsya/'
};
